import { render, staticRenderFns } from "./iossModal.vue?vue&type=template&id=059f7a07&scoped=true"
import script from "./iossModal.vue?vue&type=script&lang=js"
export * from "./iossModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f7a07",
  null
  
)

export default component.exports